import { Box, Typography } from '@material-ui/core';
import React from 'react';
import connect from './ConnectComponentRedux';

const LaterPaymentMethod = React.forwardRef(({ $state, $actions }, ref) => {
  React.useImperativeHandle(
    ref,
    () => ({
      backStep: () => {
        $actions.setLaterPayment();
        $actions.setStep($state.step - 1);
      },
      nextStep: () => {
        $actions.setLaterPayment();
        $actions.setStep($state.step + 1);
      },
    }),
    []
  );
  return (
    <Box p={3}>
      <Typography variant="body1">
        Você receberá um link por e-mail para efetuar o pagamento após a criação
        da ordem de serviço.
      </Typography>
    </Box>
  );
});

export default connect(LaterPaymentMethod);
